// extracted by mini-css-extract-plugin
export default {"button":"fgHLUq","onImage":"NK0KBv","container":"GcE_Hs","mobile":"uKkRtb","hidden":"gZrHBm","spinnerWrapper":"a5LN1r","loader":"ROSx2b"};